export interface LogConfig {
    identifier: string;
    pageName: string;
    thingToDebug: string;
    paramsToLog: any;
}
export const logger = (logConfig: LogConfig) => {
    const { identifier, pageName, thingToDebug, paramsToLog} = logConfig
    console.log(`${identifier} debug ${pageName} ${thingToDebug}: ${JSON.stringify(paramsToLog, null, 2)}`)
}